import React from "react";

const HairColoristNearMeCustomer = () => {
  return (
    <div className="hairSalonNearMeCustomer">
      <h5>
        Client Testimonials: Why SCENT is the Best Hair Colorist Salon Near Me
      </h5>
      <p>
        Our clients can’t stop raving about their experience at SCENT. Here’s
        what some of them have to say:
      </p>
      <div className="hairSalonNearMeCustomerContent">
        <p>
          <span className="quote">“</span>I was searching for a reliable hair
          colorist salon near me, and I’m so glad I found SCENT. The colorist
          really listened to what I wanted and the results were amazing!
          <span className="quote">”</span> - <span>Ria</span>
        </p>
        <p>
          <span className="quote">“</span>SCENT is hands down the best hair
          colorist salon near me. The staff is incredibly talented, and I love
          the relaxing atmosphere
          <span className="quote">”</span> - <span>Mark </span>
        </p>
        <p>
          <span className="quote">“</span>I’ve been coming to SCENT for years,
          and I wouldn’t trust anyone else with my hair. If you’re looking for a
          top-quality hair colorist salon near me, this is it!
          <span className="quote">”</span> - <span> Priya</span>
        </p>
      </div>
    </div>
  );
};

export default HairColoristNearMeCustomer;
